import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import {
  DashboardState,
  LastReload,
  StockLabel,
  StockSticker,
  TypePendingPackage
} from './types'

const actions: ActionTree<DashboardState, RootState> = {
  setDefaultState: ({ commit }) => {
    commit('SET_DEFAULT_STATE')
  },
  setClaimTotal: ({ commit }, total: number) => {
    commit('SET_CLAIM_TOTAL', total)
  },
  setReceiveTotal: ({ commit }, total: number) => {
    commit('SET_RECEIVE_TOTAL', total)
  },
  setIncome: ({ commit }, total: number) => {
    commit('SET_INCOME', total)
  },
  setDeliveryTotal: ({ commit }, total: number) => {
    commit('SET_DELIVERY_TOTAL', total)
  },
  setLastReload: ({ commit }, lastReload: LastReload) => {
    commit('SET_LAST_RELOAD', lastReload)
  },
  setStockSticker: ({ commit }, stockSticker: StockSticker) => {
    commit('SET_STOCK_STICKER', stockSticker)
  },
  setStockLabel: ({ commit }, payload: StockLabel) => {
    commit('SET_STOCK_LABEL', payload)
  },
  setPendingPickup: ({ commit }, payload: TypePendingPackage) => {
    commit('SET_PENDING_PICKUP', payload)
  },
  setPendingDelivery: ({ commit }, payload: TypePendingPackage) => {
    commit('SET_PENDING_DELIVERY', payload)
  }
}

export default actions
